import * as React from 'react';
import { StudyStartDateCriteria } from "app/pages/DiscountEditor/modules/AdditionalCriteria";
import { UnitsFilterType } from 'app/shared/model/ProductUnitFilter';
import { DateDisplay } from 'app/shared/ui/DateDisplay';
import StudyStartDateCriteriaModal from 'app/pages/DiscountEditor/components/AdditionalCriteriaEditor/StudyStartDateCriteriaModal';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface RenderStudyStartDateCriteriaProps {
    criteria: StudyStartDateCriteria
    edit: () => void
    delete: () => void
}

export default function StudyStartDateCriteriaDisplay(props: RenderStudyStartDateCriteriaProps) {
    if (!props.criteria.hasCriteria)
        return <div><StudyStartDateCriteriaModal /></div>; 

    let description = "Student must start studying "; 
    switch (props.criteria.unitsType) {
        case UnitsFilterType.MaxUnits: 
            description += " on or before " + DateDisplay(props.criteria.maxDate); 
            break; 
        case UnitsFilterType.MinUnits: 
            description += " on or after " + DateDisplay(props.criteria.minDate); 
            break; 
        case UnitsFilterType.BetweenUnits: 
            description += " between " + DateDisplay(props.criteria.minDate) + 
                           " and " + DateDisplay(props.criteria.maxDate); 
            break; 
        default: 
            description = "Unknown student start date criteria"
    }

    return <div>
            <StudyStartDateCriteriaModal />
            <div style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 14 }}>Study start date</div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: 1 }}>
                        {description}
                    </div>
                    <div style={{ display: 'flex', gap: 4 }}>
                        <Button 
                            type="text"
                            icon={<DeleteOutlined />}
                            onClick={() => props.delete()}
                            style={{ padding: '4px 8px' }}
                        />
                        <Button 
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() => props.edit()}
                            style={{ padding: '4px 8px' }}
                        />
                    </div>
                </div>
            </div>
        </div>
}
